import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AU, CA, US } from 'country-flag-icons/react/3x2'
import React, { useMemo, useState } from 'react'
import styled from 'styled-components'

import useOutsideClick from '../../../../hooks/useOutsideClick'
import useSiteSettings from '../../../../hooks/useSiteSettings'
import { langCodes } from '../../../../utils/siteSettings'
import * as Styled from './styled'

const countryOptions = [
  {
    flag: 'usa',
    href: 'https://www.designsforhealth.com',
    lang: langCodes.en_US,
    title: 'United States (English)',
  },
  {
    flag: 'canada',
    href: 'https://www.designsforhealth.ca',
    lang: langCodes.en_CA,
    title: 'Canada (English)',
  },
  {
    flag: 'australia',
    href: 'https://www.designsforhealth.com.au',
    lang: langCodes.en_AU,
    title: 'Australia (English)',
  },
]

export interface FlagProps {
  className?: string
  country: string
}

const Flag: React.FC<FlagProps> = ({ className, country }) =>
  country === 'usa' ? (
    <US className={className} />
  ) : country === 'canada' ? (
    <CA className={className} />
  ) : country === 'australia' ? (
    <AU className={className} />
  ) : (
    <div className={className} />
  )

const StyledFlag = styled(Flag)`
  position: relative;
  display: inline-block;
  // flag icons have 3:2 aspect ratio
  width: 30px;
  height: 20px;
  border-radius: 4px;
`

export interface FooterCountrySelectorProps {
  className?: string
}

export const FooterCountrySelector: React.FC<FooterCountrySelectorProps> = ({ className }) => {
  const [visibility, setVisibility] = useState(false)
  const handleChange = () => {
    setVisibility(!visibility)
  }
  const hideDropdown = () => {
    setVisibility(false)
  }

  const { lang } = useSiteSettings() || {}

  // determine current country from siteSettings.lang
  const currentCountry = useMemo(
    () => countryOptions.find((country) => country.lang === lang) || countryOptions[0],
    [lang],
  )

  const { elementRef: containerRef } = useOutsideClick<HTMLDivElement>(hideDropdown)

  return (
    <nav className={className}>
      <Styled.Container>
        <Styled.FooterCategory>COUNTRY & LANGUAGE</Styled.FooterCategory>
        <Styled.Dropdown ref={containerRef}>
          <Styled.DropdownToggle $isOpen={visibility} onClick={handleChange} type="button">
            <StyledFlag country={currentCountry.flag} />
            <Styled.Title>{currentCountry.title}</Styled.Title>
          </Styled.DropdownToggle>
          <div>
            <Styled.DropdownMenu visible={visibility}>
              {countryOptions.map((country) => (
                <li key={country.lang}>
                  <Styled.DropdownItem to={country.lang === lang ? '/' : country.href}>
                    <StyledFlag country={country.flag} />
                    <Styled.Title>{country.title}</Styled.Title>
                    {country.lang === lang && <FontAwesomeIcon icon={faCheck} />}
                  </Styled.DropdownItem>
                </li>
              ))}
            </Styled.DropdownMenu>
          </div>
        </Styled.Dropdown>
      </Styled.Container>
    </nav>
  )
}
